import { Badge } from "design-system/atoms/Badge"
import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { cn } from "design-system/utils"
import { ArrowDownToLine, ArrowUpToLine } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Flow, FlowEnum } from "schema"

const ICON_SIZE = 14

type Props = {
  flow: Flow
  className?: string
  iconOnly?: boolean
}

export function CampaignFlowBadge({ flow, className, iconOnly = false }: Props) {
  const { t } = useTranslation()

  const icon =
    flow === FlowEnum.Inbound ? (
      <ArrowDownToLine size={ICON_SIZE} />
    ) : (
      <ArrowUpToLine size={ICON_SIZE} />
    )

  const label =
    flow === FlowEnum.Inbound
      ? t("campaigns.configuration.setup.flow.inbound.title")
      : t("campaigns.configuration.setup.flow.outbound.title")

  if (iconOnly) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn("inline-flex text-muted-foreground", className)}>{icon}</span>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    )
  }

  return (
    <Badge variant="outline" className={cn("text-muted-foreground px-2 py-1", className)}>
      <div className="flex flex-row items-center gap-2">
        {icon}
        <span>{label}</span>
      </div>
    </Badge>
  )
}
